export default __webpack_public_path__ + "static/media/BUS-TICKET.e5155f6b.png";